import {Typography} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import {getTrustTypeDisplay} from '../utils';

import type {GeneralSaleTransactionType, TrustPurpose} from '@sollapay/enums';
import type {FC} from 'react';

/** `inline` is the grid card's one-line `purpose · transaction type`. */
export interface TrustAccountTypeCellProps {
  trustPurpose: TrustPurpose | null | undefined;
  generalSaleTransactionType: GeneralSaleTransactionType | null | undefined;
  layout?: 'stacked' | 'inline';
}

export const TrustAccountTypeCell: FC<TrustAccountTypeCellProps> = ({
  trustPurpose,
  generalSaleTransactionType,
  layout = 'stacked'
}) => {
  const {t} = useTranslation('trustAccounts');
  const {label, subtitle} = getTrustTypeDisplay(trustPurpose, generalSaleTransactionType, t);

  if (layout === 'inline') {
    return (
      <div data-slot="trust-account-type-cell" className="flex min-w-0 items-center gap-1.5">
        <Typography as="span" size="xs" color="secondary" className="shrink-0">
          {label}
        </Typography>
        {subtitle && (
          <>
            <span
              aria-hidden
              data-slot="separator"
              className="size-0.75 shrink-0 rounded-full bg-border"
            />
            <Typography as="span" size="xs" color="disabled" className="min-w-0">
              {subtitle}
            </Typography>
          </>
        )}
      </div>
    );
  }

  return (
    <div data-slot="trust-account-type-cell" className="flex flex-col">
      <Typography size="sm">{label}</Typography>
      {subtitle && (
        <Typography size="sm" color="tertiary">
          {subtitle}
        </Typography>
      )}
    </div>
  );
};
